<template>
  <section>
    <div class="contentBlock">
      <p class="title">忘記密碼</p>
      <form @submit="forgotPassword">
        <div class="formBlock">
          <label class="formLabel"
            >請輸入註冊的電子信箱，我們將寄送重設驗證信給您
            <input
              class="inputLayout"
              type="text"
              name=""
              placeholder="請輸入電子信箱"
              aria-label="忘記密碼請輸入電子信箱"
              value=""
              v-model="user.email"
            />
          </label>
        </div>
        <button
          @click="forgotPassword"
          class="loginBtn forgetLayout"
          title="送出"
        >
          送出
        </button>
      </form>
      <div class="additionAction">
        <router-link :to="{ name: 'login' }" title="返回登入"
          >返回登入</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MemberForgotPassword',
  metaInfo() {
    return {
      title: '忘記密碼',
    };
  },
  data() {
    return {
      user: {
        email: '',
      },
    };
  },
  methods: {
    isInputRequired() {
      if (this.user.email === '') {
        alert('請填入信箱');
        return false;
      }
      return true;
    },
    forgotPassword(e) {
      e.preventDefault();

      if (this.isInputRequired()) {
        this.$store.commit('setForgotEmail', this.user.email);
        this.$store.dispatch('forgotPassword', this.user);
        alert('已將驗證碼寄送至您的信箱了...');
        this.$router.push({ name: 'reset-password' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  border: none;
}
.contentBlock {
  margin: auto;
  width: 280px;
  @include for-tablet {
    width: 522px;
  }

  @include for-tablet-horizontal {
    padding-top: 40px;
  }
}

.title {
  margin: 20px 0 40px;
  font-family: $text-font-family;
  font-size: 24px;
  color: $color-light-text;
  text-align: center;
  letter-spacing: 1.71px;

  @include for-tablet {
    font-size: 32px;
    margin-top: 60px;
    margin-bottom: 100px;
  }
}

.formBlock {
  text-align: center;

  .formLabel {
    color: $color-light-text;
    font-size: 21px;
    letter-spacing: 1.5px;
    font-family: $text-font-family;
    line-height: 1.5;
  }

  .inputLayout {
    border: 1px solid $color-light-border;
    width: 100%;
    height: 50px;
    padding: 10px 30px;
    margin-top: 10px;
    margin-bottom: 30px;
    font-size: 18px;
    color: #979797;
    border-radius: 25px;
    box-sizing: border-box;
    &::placeholder {
      color: #979797;
    }
  }
}

.loginBtn {
  width: 100%;
  padding: 10px;
  height: 50px;
  box-sizing: border-box;
  border-radius: 32px;
  cursor: pointer;
  font-size: 21px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  letter-spacing: 1.17px;

  @include for-tablet {
    margin-bottom: 40px;
  }

  img {
    width: 21px;
    margin-right: 10px;
  }
}

.forgetLayout {
  background-color: $color-light-btn-bg;
}

.additionAction {
  text-align: center;
  margin: 10px 0 40px;

  @include for-tablet {
    margin-bottom: 60px;
  }

  a {
    color: $color-light-text;
    text-decoration: underline;
  }
}
</style>
